import { render } from "./deathsummaryreport.vue?vue&type=template&id=0175147c&scoped=true"
import script from "./deathsummaryreport.js?vue&type=script&lang=js"
export * from "./deathsummaryreport.js?vue&type=script&lang=js"

import "./deathsummaryreport.vue?vue&type=style&index=0&id=0175147c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0175147c"]])

export default __exports__